import {
  FlatfileRecord,
  TPrimitive,
  TRecordDataWithLinks,
} from "@flatfile/hooks";

function validateStripeCustomerId(stripeCustomerId: string) {
  return stripeCustomerId.startsWith("cus_");
}

export function flatFileRecordModifiers(
  record: FlatfileRecord<TRecordDataWithLinks<TPrimitive>>,
) {
  const stripeCustomerId = record.get("stripeCustomerId")?.toString();

  if (stripeCustomerId && !validateStripeCustomerId(stripeCustomerId)) {
    record.addError(
      "stripeCustomerId",
      "Invalid input, should start with 'cus_'",
    );
  }
  return record;
}
